import React, { useEffect,useLayoutEffect, useRef, useState } from "react";
import { Dropdown, Tab } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import fetchAPI from '../../../common/fetchAPI';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { AlignEnd } from "react-bootstrap-icons";
import CustomPagination from "../../../common/Pagination";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from "react-i18next";
import Select, { StylesConfig } from 'react-select';
import { EmailNotificationPreferenceItem } from "./EmailNotificationPreferenceItem";
import { getvueAccountEMailNotificationPreferencessAsync, UpdateAccountEmailNotificationPreferenceAsync, resetSelectedRecordObjectInState } from "./emailNotificationPreferenceSlice";
import { KTIcon } from "../../../_metronic/helpers";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,getValueFromResource} from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";


const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const EmailNotificationPreference = () => {
    
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { EmailNotificationPreferenceList, isReload, isLoading } = useAppSelector((state) => state.emailNotificationPreference);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, manageTerminologyList } = useAppSelector((state) => state.globalState);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);



    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };
    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };


    const filteredData: any = getFilteredList(EmailNotificationPreferenceList, searchTerm);


    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = EmailNotificationPreferenceList.length;
    const recordsFiltered = filteredData.length;

    useEffect(() => {
        if (isReload) {
            dispatch(getvueAccountEMailNotificationPreferencessAsync());
        }

    }, [isReload])

    useEffect(() => {
        dispatch(getvueAccountEMailNotificationPreferencessAsync());
    }, [dispatch])

    const handleOnClickEvent = (e: any) => {
        e.preventDefault();
        dispatch(UpdateAccountEmailNotificationPreferenceAsync({ data: EmailNotificationPreferenceList }))
            .unwrap()
            .then((originalPromiseResult) => {
                ShowToast("EMail Notifications Update Successfully", 'Success', "success", "toast-top-right");
                dispatch(getvueAccountEMailNotificationPreferencessAsync());
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('handleSubmit-UpdateAccountEmailNotificationPreferenceAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    return (
        <>
            {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top fixed-top bg-white">
                    <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1"  >
                        {/* {t('Email Notification Preferences')} */}
                        {getValueFromResource('Email Notification Preferences', dispatch, t)}
                        <div
                            style={{ marginBottom: "2px" }}
                            data-tooltip-id="tooltip-emailPreference"
                            data-tooltip-content={getValueFromResource("Configure which system events send email notifications and determine who receives them.", dispatch, t)}
                        >
                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                        </div>
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearch}
                                placeholder=
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                /> */}
                                 <PageSizeSelect onChange={handlePageSizeChange} />


                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        {IsEdit &&
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        } */}
                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(currentPage - 1) * pageSize}
                                        t={t}
                                        recordsFiltered={recordsFiltered}
                                    />
                                </div>
                            </>
                        )}

                        {IsEdit && (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        )}
                        {IsEdit &&
                        <button ref={modelRef} type="button"
                            className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                            onClick={(e) => { handleOnClickEvent(e) }}
                            style={{ marginRight: '2px' }}
                        >
                            {/* {t('Update Email Notification')} */}
                            {getValueFromResource('Update Email Notification',dispatch, t)}
                        </button>
                        }
                    </div>
                </div>
                {IsList &&
                // <div className="card-body">
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <EmailNotificationPreferenceItem EmailNotificationPreferenceList={currentItems}/>
                    </div>
                </div>
                }
            </div>
            <ReactTooltip
                id="tooltip-emailPreference"
                style={TOOLTIP_STYLE}
                place="bottom"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}
export default EmailNotificationPreference;